<ng-container *ngIf='loading'>
    <div class="loading">
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
    </div>
  </ng-container>
  
  <ng-container *ngIf="role && role !== 'CUSTOMER'">
    <h1>UNAUTHORISED ACCESS</h1> <br>
    <h3>Please Login as CUSTOMER, redirecting ...</h3>
    {{unauthorised()}}
  </ng-container>
  
  <ng-container *ngIf="role && role === 'CUSTOMER'">
    <div class="wrapper ">
      <br>
      <div>
        <div class="content">
          <ng-container *ngIf="alloys">
            <div class="alert alert-danger" role="alert" *ngIf="alloys.length === 0">
              No Standard Alloys
            </div>
            <div class="alert alert-primary" role="alert" *ngIf="alloys.length !== 0">
              Standard Alloys
            </div>
            <div class="card">
            <div class="card-body">
              <table class="table table-hover">
                <thead class=" text-primary">
                  <tr>
                    <th scope="col">Alloy ID</th>
                    <th scope="col">Alloy Name</th>
                    <th scope="col">Iron</th>
                    <th scope="col">Grade</th>
                    <th scope="col">GEL</th>
                    <th scope="col">WEL</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let alloy of alloys">
                    <td>{{ alloy._id }}</td>
                    <td>{{ alloy.name }}</td>
                    <td>
                      <div *ngFor="let iron of alloy.iron">
                        {{ iron.item_text }}
                      </div>
                    </td>
                    <td>{{ alloy.grade }}</td>
                    <td>{{ alloy.calculatedValues.GEL }}</td>
                    <td>{{ alloy.calculatedValues.WEL }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-container>
  